import { useAppState } from '../hooks/useAppState'
import { useError } from '../hooks/useError'
import { useSubmissionId } from '../hooks/useSubmissionId'

export type ErrorProps = {
  error: string
}

export function Error() {
  const setStatus = useAppState((s) => s.setStatus)
  const reset = useSubmissionId((s) => s.reset)
  const error = useError((s) => s.error)

  return (
    <div className='error'>
      <div style={{ marginBottom: 10 }}>
        <h3>Something went wrong...</h3>
        <p className='small'>{error || 'We encounted an unexpected issue.'}</p>
      </div>
      <div style={{ marginTop: 10 }}>
        <button
          onClick={() => {
            setStatus('intake')
            reset()
          }}
        >
          Restart
        </button>
      </div>
    </div>
  )
}
